var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintingInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.54,197.54a80.51,80.51,0,0,0-60.35-46.14c-20-3.05-41.13,1.53-60.13-5.36-17.79-6.45-30.65-21.9-41.34-37.51s-20.45-32.42-35.34-44.1c-20-15.7-47.23-20.07-72.33-16.1C126.79,54.23,91.8,74,73.6,107.05s-19.21,78.6-4.29,113.24A206.91,206.91,0,0,0,96.1,265.4a109.37,109.37,0,0,0,85,41.35l178.81,1.82a79,79,0,0,0,73.65-111Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Printer--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.54,195.71h197a3.51,3.51,0,0,1,3.51,3.51v79a0,0,0,0,1,0,0H150a0,0,0,0,1,0,0v-79A3.51,3.51,0,0,1,153.54,195.71Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,195.71h197a3.51,3.51,0,0,1,3.51,3.51v79a0,0,0,0,1,0,0H150a0,0,0,0,1,0,0v-79A3.51,3.51,0,0,1,153.54,195.71Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.44,
    y: 139.06,
    width: 174.04,
    height: 222.17,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.37,
    y: 138.27,
    width: 174.04,
    height: 42.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.07,
    y: 174.43,
    width: 66.32,
    height: 10.73,
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.07,
    y: 227.88,
    width: 155.49,
    height: 15.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.07,
    y: 243.28,
    width: 155.49,
    height: 15.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,178.05h.3v2.82h-.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.27,179.64v1.23H184v-1.2c0-.45-.23-.68-.63-.68a.7.7,0,0,0-.74.77v1.11h-.29v-2.12h.27v.39a.91.91,0,0,1,.81-.4A.81.81,0,0,1,184.27,179.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.79,178.75l-.94,2.12h-.3l-.94-2.12h.3l.79,1.81.81-1.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,179.81a1.08,1.08,0,1,1,1.08,1.08A1,1,0,0,1,186.92,179.81Zm1.86,0A.77.77,0,0,0,188,179a.83.83,0,1,0,.78.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.59,178.08a.21.21,0,0,1,.21-.2.2.2,0,0,1,.21.2.21.21,0,0,1-.21.21A.21.21,0,0,1,189.59,178.08Zm.07.67h.28v2.12h-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53,179.81a1,1,0,0,1,1.09-1.07.92.92,0,0,1,.83.42l-.21.14a.73.73,0,0,0-.62-.31.83.83,0,0,0,0,1.65.73.73,0,0,0,.62-.31l.21.14a.92.92,0,0,1-.83.42A1,1,0,0,1,190.53,179.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.82,179.9h-1.77a.79.79,0,0,0,.83.74.82.82,0,0,0,.65-.28l.16.19a1.12,1.12,0,0,1-1.93-.74,1,1,0,1,1,2.06,0Zm-1.77-.21h1.5a.75.75,0,0,0-1.5,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.21,179l-.11.84h.58v.23h-.6l-.1.76h-.21l.09-.76H198l-.09.76h-.22l.09-.76h-.57v-.23h.6l.1-.84h-.57v-.22h.6l.1-.77h.22l-.1.77H199l.09-.77h.22l-.09.77h.57V179Zm-.22,0h-.82l-.11.84h.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,180.06c0,.47-.34.84-1,.84a1.49,1.49,0,0,1-1-.37l.15-.23a1.22,1.22,0,0,0,.87.33c.47,0,.72-.22.72-.57s-.23-.56-.76-.56h-.2v-.21l.78-1h-1.44v-.26h1.81v.21l-.79,1C201.7,179.29,202,179.61,202,180.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.81,180.13h-.57v.74H204v-.74h-1.59v-.21l1.5-1.87h.32l-1.44,1.82H204v-.65h.28v.65h.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,180c0,.48-.33.86-1,.86a1.46,1.46,0,0,1-1-.37l.14-.23a1.21,1.21,0,0,0,.86.33c.48,0,.74-.23.74-.58s-.23-.58-.94-.58h-.6l.14-1.42h1.54v.26h-1.29l-.09.9h.36C206.65,179.21,207,179.54,207,180Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,180a.88.88,0,0,1-1,.87c-.75,0-1.16-.52-1.16-1.41s.52-1.46,1.29-1.46a1.3,1.3,0,0,1,.67.15l-.12.23a1,1,0,0,0-.55-.13c-.61,0-1,.39-1,1.16,0,.06,0,.14,0,.23a.9.9,0,0,1,.86-.49A.85.85,0,0,1,209.46,180Zm-.29,0c0-.37-.27-.61-.71-.61a.65.65,0,0,0-.72.62c0,.31.26.6.74.6A.62.62,0,0,0,209.17,180Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.72,180.61v.26h-2v-.2l1.17-1.15c.32-.32.38-.51.38-.7s-.23-.53-.66-.53a1,1,0,0,0-.77.32l-.2-.18a1.27,1.27,0,0,1,1-.4c.57,0,.93.29.93.76a1.15,1.15,0,0,1-.46.88l-1,.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.23,155.55h1.68v9.06h-1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.41,155.55v9.06H282l-5-6.14v6.14h-1.67v-9.06h1.39l5,6.13v-6.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07,155.55l-3.95,9.06h-1.66l-4-9.06h1.83l3,7,3-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.29,160.08a4.89,4.89,0,1,1,4.88,4.66A4.64,4.64,0,0,1,294.29,160.08Zm8.06,0a3.19,3.19,0,1,0-3.18,3.18A3.09,3.09,0,0,0,302.35,160.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,155.55h1.68v9.06h-1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.32,160.08a4.91,4.91,0,0,1,8.44-3.15l-1.09,1a3.17,3.17,0,0,0-2.42-1.07,3.19,3.19,0,1,0,0,6.37,3.17,3.17,0,0,0,2.42-1.07l1.09,1a4.9,4.9,0,0,1-8.44-3.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.17,163.2v1.41h-6.79v-9.06H326V157h-4.93v2.35h4.37v1.39h-4.37v2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67,193.56a14.41,14.41,0,0,1-5.45,0,14.41,14.41,0,0,1,5.45,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.63,195.83a12.23,12.23,0,0,1,1.82-4.75,6.59,6.59,0,0,1-.67,2.47A6.51,6.51,0,0,1,304.63,195.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.63,193.56a8,8,0,0,1-4.05,0c0-.15.91-.26,2-.26S311.63,193.41,311.63,193.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.29,195.28a4.8,4.8,0,0,1,.51-2.13c.41-1.12.85-2,1-1.94a4.74,4.74,0,0,1-.51,2.12C313.87,194.46,313.43,195.33,313.29,195.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.5,193.56a31.67,31.67,0,0,1-8.1,0,31.67,31.67,0,0,1,8.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.07,
    y: 217.15,
    width: 155.49,
    height: 10.73,
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,236.4c0,.14-7.47.26-16.69.26s-16.69-.12-16.69-.26,7.47-.26,16.69-.26S220.86,236.26,220.86,236.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.46,236.76a51.84,51.84,0,0,1-7.28.26,51.84,51.84,0,0,1-7.28-.26,50.08,50.08,0,0,1,7.28-.26A50.08,50.08,0,0,1,275.46,236.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,235.87c0,.14-.72.26-1.6.26s-1.6-.12-1.6-.26.72-.26,1.6-.26S296,235.72,296,235.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.82,236.22a39.71,39.71,0,0,1-6.48.26,39.71,39.71,0,0,1-6.48-.26,41.1,41.1,0,0,1,6.48-.26A41.1,41.1,0,0,1,323.82,236.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,251.32c0,.14-11.32.26-25.3.26s-25.3-.12-25.3-.26,11.33-.26,25.3-.26S238.08,251.17,238.08,251.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.8,251.49a33.49,33.49,0,0,1-5.95.26,33.49,33.49,0,0,1-6-.26,34.66,34.66,0,0,1,6-.26A34.66,34.66,0,0,1,272.8,251.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,251.32a10.39,10.39,0,0,1-4.62,0,10.39,10.39,0,0,1,4.62,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.05,251a74.41,74.41,0,0,1-12.43,0,74.41,74.41,0,0,1,12.43,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.86,
    y: 281.6,
    width: 73.26,
    height: 9.55,
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05,268.11a71.59,71.59,0,0,1-8.71.26,71.35,71.35,0,0,1-8.7-.26,73.86,73.86,0,0,1,8.7-.26A74.1,74.1,0,0,1,313.05,268.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05,274.52a74.1,74.1,0,0,1-8.71.26,73.86,73.86,0,0,1-8.7-.26,71.35,71.35,0,0,1,8.7-.26A71.59,71.59,0,0,1,313.05,274.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7,274.52a74.1,74.1,0,0,1-8.71.26,74.1,74.1,0,0,1-8.71-.26,71.59,71.59,0,0,1,8.71-.26A71.59,71.59,0,0,1,280.7,274.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7,267.79c0,.14-5.82.26-13,.26s-13-.12-13-.26,5.81-.26,13-.26S280.7,267.65,280.7,267.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05,286.85a71.59,71.59,0,0,1-8.71.26,71.35,71.35,0,0,1-8.7-.26,73.86,73.86,0,0,1,8.7-.26A74.1,74.1,0,0,1,313.05,286.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66,286.85a71.59,71.59,0,0,1-8.71.26,71.59,71.59,0,0,1-8.71-.26,74.1,74.1,0,0,1,8.71-.26A74.1,74.1,0,0,1,281.66,286.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.16,
    y: 153.88,
    width: 5.02,
    height: 5.02,
    rx: 1.6,
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.29,160V160a.29.29,0,0,0,.29.29h4.82v-5a.29.29,0,0,0-.29-.29h0a.3.3,0,0,0-.3.29v4.32l-4.23,0A.29.29,0,0,0,180.29,160Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,155.62c0,.14-6.45.26-14.4.26s-14.4-.12-14.4-.26,6.44-.26,14.4-.26S216.56,155.47,216.56,155.62Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.21,158.38a53.75,53.75,0,0,1-7.54.26,53.75,53.75,0,0,1-7.54-.26,55.64,55.64,0,0,1,7.54-.26A55.64,55.64,0,0,1,203.21,158.38Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.41,360.43c0-2.05-.09-90.3-.23-222.16l.23.23-174,0h0l.26-.26c0,82.36,0,158.85,0,222.16l-.22-.21,174,.21-174,.22h-.21v-.22c0-63.31,0-139.8,0-222.16V138h.28l174,0h.24v.24C339.51,270.13,339.41,358.39,339.41,360.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,199.29c0,.14-9.31.26-20.79.26s-20.8-.12-20.8-.26,9.31-.26,20.8-.26S251.82,199.14,251.82,199.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,203.27c0,.14-9.31.26-20.79.26s-20.8-.12-20.8-.26,9.31-.26,20.8-.26S251.82,203.12,251.82,203.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,207.25a59.12,59.12,0,0,1-7.78.26,59,59,0,0,1-7.77-.26A59,59,0,0,1,218,207,59.12,59.12,0,0,1,225.78,207.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.47,195c0,.14-17.51.26-39.1.26s-39.1-.12-39.1-.26,17.5-.26,39.1-.26S252.47,194.87,252.47,195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.82,222.52c0,.14-7.8.26-17.43.26s-17.44-.12-17.44-.26,7.8-.26,17.44-.26S221.82,222.37,221.82,222.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.08,222.52a83.15,83.15,0,0,1-9.23.26,83.15,83.15,0,0,1-9.23-.26,80.32,80.32,0,0,1,9.23-.26A80.32,80.32,0,0,1,276.08,222.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.48,222.52a45.87,45.87,0,0,1-6.84.26,46,46,0,0,1-6.85-.26,44.39,44.39,0,0,1,6.85-.26A44.31,44.31,0,0,1,302.48,222.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3,222.52a45.76,45.76,0,0,1-6.84.26,45.76,45.76,0,0,1-6.84-.26,44.21,44.21,0,0,1,6.84-.26A44.21,44.21,0,0,1,325.3,222.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.51,460.1V288a10.57,10.57,0,0,1,10.57-10.57H426.92A10.57,10.57,0,0,1,437.49,288V460.1Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.06,
    cy: 317.94,
    r: 16.57,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.31,317.94a30.52,30.52,0,0,0-.74-4.92,19.31,19.31,0,0,0-2.26-5.34,20.05,20.05,0,0,0-24.06-8.52,18.7,18.7,0,0,0-5.06,2.73,21.56,21.56,0,0,0-2.26,1.93,23,23,0,0,0-2,2.31,19.9,19.9,0,0,0,0,23.61,24.27,24.27,0,0,0,2,2.32,21.46,21.46,0,0,0,2.26,1.92,18.7,18.7,0,0,0,5.06,2.73,20.11,20.11,0,0,0,24.06-8.51,19.49,19.49,0,0,0,2.26-5.35,30.5,30.5,0,0,0,.74-4.91,1.14,1.14,0,0,1,0,.32c0,.26,0,.57,0,1a9.78,9.78,0,0,1-.13,1.57,15.78,15.78,0,0,1-.39,2.11,18.94,18.94,0,0,1-2.2,5.45,20.4,20.4,0,0,1-13.75,9.71,20.51,20.51,0,0,1-10.78-.85,19.28,19.28,0,0,1-5.2-2.79,21.68,21.68,0,0,1-2.33-2,23.07,23.07,0,0,1-2-2.38,20.4,20.4,0,0,1,0-24.29,23.07,23.07,0,0,1,2-2.38,21.68,21.68,0,0,1,2.33-2,19,19,0,0,1,5.2-2.78,20.42,20.42,0,0,1,10.78-.86,20.4,20.4,0,0,1,13.75,9.71,18.94,18.94,0,0,1,2.2,5.45,15.62,15.62,0,0,1,.39,2.12,9.67,9.67,0,0,1,.13,1.56c0,.4,0,.72,0,1A1.19,1.19,0,0,1,333.31,317.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.4,353.86c0,.15-83.69.26-186.92.26S62.55,354,62.55,353.86s83.68-.26,186.93-.26S436.4,353.72,436.4,353.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.03 234.75 349.03 249.45 339.38 249.45 339.38 277.42 339.38 279.78 363.73 279.78 363.73 234.75 349.03 234.75",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.76 249.45 155.76 234.75 141.05 234.75 141.05 277.64 165.41 277.64 165.41 277.42 165.41 249.45 155.76 249.45",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.69 460.1 134.74 454.93 134.74 441.35 361.69 441.35 361.69 460.1",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.96,
    y: 378.77,
    width: 217.16,
    height: 40.48,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.83,277.42c0,.14-78.58.26-175.5.26s-175.51-.12-175.51-.26,78.57-.26,175.51-.26S423.83,277.27,423.83,277.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.23,354.38c-.15,0-.26-17.16-.26-38.33s.11-38.32.26-38.32.26,17.15.26,38.32S264.37,354.38,264.23,354.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.87,352.69c-.14,0-.26-16.84-.26-37.62s.12-37.63.26-37.63.26,16.85.26,37.63S122,352.69,121.87,352.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.55,312.42s-.37.34-.92,1a7.25,7.25,0,0,0-1.5,3.39,7,7,0,0,0,1.22,5.22,7.29,7.29,0,0,0,2.4,2.13,7,7,0,0,0,9.06-2.16A7.11,7.11,0,0,0,320,316.8a7.26,7.26,0,0,0-1.52-3.37c-.56-.7-1-1-.93-1s.12.05.31.19a6.07,6.07,0,0,1,.78.71,7.23,7.23,0,0,1,1.73,3.45,7.43,7.43,0,0,1-1.16,5.57,7.44,7.44,0,0,1-9.69,2.34,7.78,7.78,0,0,1-2.55-2.3,7.37,7.37,0,0,1-1.2-5.57,7.19,7.19,0,0,1,1.71-3.45,6.37,6.37,0,0,1,.77-.72C308.44,312.47,308.54,312.4,308.55,312.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.06,308.36a68.33,68.33,0,0,1,0,11.91,68.33,68.33,0,0,1,0-11.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.12,
    y: 300.88,
    width: 69.86,
    height: 35.69,
    rx: 1.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.48 310.2 190.55 309.27 189.6 310.22 189.6 317.9 190.6 318.9 191.54 317.96 191.48 310.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.48 320.15 190.55 319.22 189.6 320.17 189.6 327.85 190.6 328.85 191.54 327.91 191.48 320.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.5 320.15 200.56 319.22 199.61 320.17 199.61 327.85 200.61 328.85 201.55 327.91 201.5 320.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.56 310.2 200.63 309.27 199.67 310.22 199.67 317.9 200.67 318.9 201.62 317.96 201.56 310.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.63 308.16 190.7 309.09 191.65 310.04 199.33 310.04 200.33 309.04 199.39 308.1 191.63 308.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.63 328.13 190.7 329.06 191.65 330.01 199.33 330.01 200.33 329.01 199.39 328.07 191.63 328.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.63 318.16 190.7 319.09 191.65 320.04 199.33 320.04 200.33 319.04 199.39 318.1 191.63 318.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.55 310.04 208.62 309.11 207.67 310.06 207.67 317.74 208.67 318.74 209.61 317.8 209.55 310.04",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.55 319.99 208.62 319.06 207.67 320.01 207.67 327.69 208.67 328.69 209.61 327.75 209.55 319.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.56 319.99 218.63 319.06 217.68 320.01 217.68 327.69 218.68 328.69 219.62 327.75 219.56 319.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.63 310.04 218.7 309.11 217.74 310.06 217.74 317.74 218.74 318.74 219.69 317.8 219.63 310.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.7 308 208.77 308.93 209.72 309.88 217.4 309.88 218.4 308.88 217.46 307.94 209.7 308",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.7 327.97 208.77 328.9 209.72 329.85 217.4 329.85 218.4 328.85 217.46 327.91 209.7 327.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.7 317.99 208.77 318.93 209.72 319.88 217.4 319.88 218.4 318.88 217.46 317.94 209.7 317.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.43,339.36s.2,0,.57-.09a2.66,2.66,0,0,0,2-2,7.3,7.3,0,0,0,.06-1.51c0-1.12,0-2.39,0-3.83,0-5.78,0-14.1-.08-24.38,0-1.28,0-2.6,0-3.95v-2a2.52,2.52,0,0,0-.61-1.79,2.4,2.4,0,0,0-1.71-.85H222l-19.32,0-44.27,0a2.45,2.45,0,0,0-2.15,1.31,2.48,2.48,0,0,0-.27,1.3v7.23c0,3.83,0,7.59,0,11.3s0,7.34,0,10.9v5.28a2.59,2.59,0,0,0,.79,2.18,2.36,2.36,0,0,0,1,.55,4.29,4.29,0,0,0,1.21.09l36.15.06,24.38.08,6.62.05,1.73,0,.59,0-.59,0-1.73,0-6.62,0-24.38.09L159,339.6a4.8,4.8,0,0,1-1.34-.1,2.93,2.93,0,0,1-1.22-.67,3.07,3.07,0,0,1-1-2.53V331c0-3.56,0-7.2,0-10.9V301.59a3.1,3.1,0,0,1,.32-1.54,3,3,0,0,1,2.62-1.59l44.27,0,19.32,0h4.46c.74,0,1.44,0,2.18,0a2.88,2.88,0,0,1,2,1,2.93,2.93,0,0,1,.69,2.06v2c0,1.35,0,2.67,0,3.95,0,10.28-.06,18.6-.08,24.38,0,1.44,0,2.71,0,3.83a7,7,0,0,1-.09,1.54,2.63,2.63,0,0,1-.59,1.14,2.72,2.72,0,0,1-1.49.86A2,2,0,0,1,228.43,339.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.49,378.77c0,.14-83.82.26-187.19.26s-187.22-.12-187.22-.26,83.81-.26,187.22-.26S437.49,378.63,437.49,378.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.96,
    y: 441.35,
    width: 236.85,
    height: 9.38,
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,450.72s0-.75,0-2.29,0-3.88,0-7.08l.06.06-236.84.2h0l.26-.26v9.37l-.26-.26,167.75.11,50.56.08,13.74,0h3.57l1.23,0s-.39,0-1.19,0l-3.54,0-13.68,0-50.5.08L128,451h-.26v-9.89H128l236.84.19h.07v.07c0,3.22,0,5.57,0,7.12S364.81,450.72,364.81,450.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.74 441.08 134.74 433.11 141.54 433.11 134.74 428.75 134.74 419.25 358.11 419.25 358.11 430.3 353.24 432.65 358.11 432.71 358.11 441.25 134.74 441.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.74 419.25 134.74 428.75 141.28 432.94 134.74 432.94 134.74 441.08 150.93 441.08 150.93 419.25 134.74 419.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.24,432.65c0,.15-45.29.35-101.15.45s-101.16.06-101.16-.08,45.28-.34,101.16-.44S353.24,432.51,353.24,432.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.24,427.1c0,.14-45.29.34-101.15.45s-101.16.06-101.16-.08,45.28-.34,101.16-.45S353.24,427,353.24,427.1Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484,460.1c0,.14-105,.26-234.53.26S15,460.24,15,460.1s105-.26,234.54-.26S484,460,484,460.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.28,277.44l-14.76.21,2.07,67.16-11.9,29.76c11.64.3,26.41-8.2,28.19-19.71.8-5.2-.11-10.49-.65-15.73-1-9.9-.76-19.89-.48-29.84.19-6.84.42-13.88,3.19-20.14s8.71-11.63,15.55-11.57Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "88.54 321.81 90.27 360.41 106.52 359.24 110.16 318.74 88.54 321.81",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,352.14s-11.44,8.12-17,1.09l-1.45,3.41-6.5,24.25a3.25,3.25,0,0,0,1.83,3.9,3.11,3.11,0,0,0,3.32-.64c4.71-4.47,21.93-21,21.76-23.26l-.06-6a3,3,0,0,0-1.93-2.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.56,385l24.53-26.14v1.3c.12,1.41-.5,2-1.17,2.88-2,2.67-7.48,8.66-20.5,21.16a3.14,3.14,0,0,1-2.86.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5,354.94a1.9,1.9,0,0,0-.53,2.48,1.82,1.82,0,0,0,2.45.55,2,2,0,0,0,.55-2.63,1.89,1.89,0,0,0-2.62-.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.63,371.57c-.17.08-.86-1.53-2.68-2.4s-3.5-.51-3.53-.69.36-.32,1.08-.42a5,5,0,0,1,2.75.5,4.82,4.82,0,0,1,2,1.89C91.66,371.09,91.71,371.54,91.63,371.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,375.67c-.15.13-1.13-.87-2.72-1.33s-2.95-.21-3-.4,1.4-.8,3.2-.25S89.59,375.59,89.43,375.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.72,366.31c-.14.15-1.64-1.4-4-2.34s-4.54-.87-4.55-1.08,2.24-.58,4.8.46S95.87,366.23,95.72,366.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.27,358.93c-.08.18-1.78-.53-4-.62s-4,.43-4,.24,1.69-1,4.06-.92S96.37,358.78,96.27,358.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,358.24a2.65,2.65,0,0,1,.17-1.15,8,8,0,0,1,1.47-2.82,3.56,3.56,0,0,1,1.82-1.4,1.28,1.28,0,0,1,1.35.54,2.06,2.06,0,0,1,.22,1.45,4.45,4.45,0,0,1-4.59,3.33A5.16,5.16,0,0,1,87,354.61a1.78,1.78,0,0,1,.19-1.48,1.26,1.26,0,0,1,1.4-.41,4.37,4.37,0,0,1,1.79,1.41A8.89,8.89,0,0,1,92,356.86a2.68,2.68,0,0,1,.27,1.13A14,14,0,0,0,90,354.45a4.08,4.08,0,0,0-1.6-1.19.65.65,0,0,0-.76.22,1.23,1.23,0,0,0-.07,1,4.62,4.62,0,0,0,3.93,3.06,3.86,3.86,0,0,0,3.93-2.77,1.5,1.5,0,0,0-.11-1,.69.69,0,0,0-.74-.31A3.26,3.26,0,0,0,93,354.58,11.89,11.89,0,0,0,91,358.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.78 287.71 34.9 325.45 50.77 334.96 76.44 298.8 54.78 287.71",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.38,320.4l-.65,1.05s-22.16-3.78-24.42-.52l35.41,21.49,6.67-12.07A23.71,23.71,0,0,1,37.38,320.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.52,331.94a1.7,1.7,0,0,1,0,2.26,1.63,1.63,0,0,1-2.24,0,1.78,1.78,0,0,1,0-2.39,1.7,1.7,0,0,1,2.33.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72,342.42l1.61-2.9L14.8,320s-2-.27-2.49.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.55,321.47c-.1.18.72.78,1.23,1.85s.53,2.08.73,2.11.55-1.13-.1-2.42S36.61,321.29,36.55,321.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9,320.75c-.14.15.43.89.58,2s-.16,2,0,2.06.88-.81.67-2.16S32,320.59,31.9,320.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.09,323.92c.14.13.9-.59,1-1.8s-.45-2.09-.61-2,0,.91-.09,1.91S26.93,323.8,27.09,323.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.72,233.48s11.59,16,9.68,30.77c-1.45,11.27-4.2,13.19-4.2,13.19l-35.54,0-7.59-47.69,11,.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.83,255l-.23.14a16.39,16.39,0,0,0-7.91,14.79l4.22,60.29,20.55.62,3.77-53,10.57-.6L106.27,257A10.64,10.64,0,0,0,92.83,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.94,306l33.81-70s4.74-7,11.39-6.65S138.23,243,138.23,243v33.85l-14.56-.32-32.9-3.16L78.24,297.15l-14.7,21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.16,247.55a1.76,1.76,0,0,1-.47-.15l-1.32-.53-4.84-2c-4.09-1.65-9.77-3.86-16.12-6.07s-12.18-4-16.41-5.26l-5-1.45-1.36-.41a1.89,1.89,0,0,1-.47-.17,2.27,2.27,0,0,1,.49.08l1.38.33c1.2.28,2.93.73,5.06,1.32,4.26,1.16,10.11,2.92,16.48,5.13s12,4.48,16.09,6.21c2,.86,3.67,1.59,4.79,2.11l1.28.6A2.44,2.44,0,0,1,146.16,247.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,240.29a23.51,23.51,0,0,1-3.08-.12c-1.9-.12-4.52-.25-7.43-.32l-7.44-.15a21.09,21.09,0,0,1-3.08-.16,3,3,0,0,1,.82-.09l2.26-.07c1.91,0,4.54,0,7.45,0s5.55.26,7.45.45c.95.1,1.71.19,2.24.27A2.82,2.82,0,0,1,147.16,240.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,253a13.79,13.79,0,0,0-2.74-.33,12.1,12.1,0,0,0-7,2.33,16.5,16.5,0,0,0-6,9.14c-1.18,4-1.16,8.76-.79,13.62.73,9.74,1.39,18.55,1.88,25,.21,3.15.38,5.73.51,7.58,0,.85.08,1.54.11,2.06a3.3,3.3,0,0,1,0,.72,4.69,4.69,0,0,1-.1-.71c-.06-.52-.13-1.2-.21-2.06-.17-1.84-.4-4.41-.68-7.56-.52-6.45-1.24-15.26-2-25-.37-4.87-.38-9.65.85-13.78a16.69,16.69,0,0,1,6.22-9.31,12.05,12.05,0,0,1,7.22-2.23,9.3,9.3,0,0,1,2.06.29A3.3,3.3,0,0,1,102.1,253Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.11,277.19a1.65,1.65,0,0,1-.45-.06c-.3-.06-.73-.14-1.28-.29a36,36,0,0,1-4.56-1.5,53.11,53.11,0,0,1-13.51-8.16,107.63,107.63,0,0,1-11.38-11c-1.37-1.49-2.45-2.72-3.19-3.57a11.78,11.78,0,0,1-1.11-1.37,11.44,11.44,0,0,1,1.26,1.23L105.2,256a126.35,126.35,0,0,0,11.44,10.81A56.65,56.65,0,0,0,130,275a45,45,0,0,0,4.47,1.65A14.09,14.09,0,0,1,136.11,277.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,267.91c.14,0-.12,6.62-.59,14.76s-1,14.73-1.11,14.73.12-6.62.59-14.76S113.18,267.9,113.33,267.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.29,154.75a3.08,3.08,0,0,0,.17-1.3A3.63,3.63,0,0,0,112,152a9.94,9.94,0,0,0-1.33-1.6,8.44,8.44,0,0,1-1.59-2.07,7.47,7.47,0,0,1-.82-2.9,7.19,7.19,0,0,1,.51-3.29,19.44,19.44,0,0,1,1.66-3.11,16,16,0,0,0,1.54-3.06,5.84,5.84,0,0,0,.23-3.08c-.42-2-1.49-3.57-2-5.08a5.9,5.9,0,0,1-.27-3.72,3.5,3.5,0,0,1,.43-.94,1,1,0,0,1,.23-.27,9.6,9.6,0,0,0-.47,1.26,6,6,0,0,0,.42,3.54c.53,1.45,1.64,3,2.12,5.11a6.18,6.18,0,0,1-.22,3.34,16.45,16.45,0,0,1-1.58,3.17,19.91,19.91,0,0,0-1.63,3,7.07,7.07,0,0,0-.51,3.07,7.2,7.2,0,0,0,.74,2.73,8.22,8.22,0,0,0,1.47,2,9.59,9.59,0,0,1,1.31,1.7,3.84,3.84,0,0,1,.47,1.57,2.32,2.32,0,0,1-.18,1C112.39,154.67,112.3,154.76,112.29,154.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,146.86a4.72,4.72,0,0,0,4.15,3.08,5.69,5.69,0,0,0,4.75-2.3,7.18,7.18,0,0,0,1.28-5.19A8.62,8.62,0,0,1,150,140c.2-1.16,1.1-2.07,1.46-3.19.63-2-.74-4.26-2.64-5.19a9.56,9.56,0,0,0-6.21-.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.65,121.53c-2,1.78-1.4,4.3-.62,6s1.73,3.49,1.65,5.38-1.25,3.63-1.89,5.46a10.4,10.4,0,0,0,.16,7.17c.68,1.71,1.8,3.21,2.49,4.92s.86,3.81-.29,5.25a3.29,3.29,0,0,0,2.41-1.72,6.48,6.48,0,0,0,.72-3c.13-3.9-1.52-7.78-.83-11.62.39-2.23,1.57-4.33,1.55-6.6s-1.24-4.34-2.09-6.45-1.27-4.71.12-6.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.68,114.41a7.53,7.53,0,0,0-5.89,3.21,4.94,4.94,0,0,0,.82,6.3c1.72,1.36,4.28,1.09,6.18,0a7.05,7.05,0,0,0,3.19-3.52,5.06,5.06,0,0,0-.45-4.63,3.94,3.94,0,0,0-4.25-1.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.81,114.07a10.3,10.3,0,0,1,6.63-5.55,17.06,17.06,0,0,1,8.83.06,51.26,51.26,0,0,1,8.35,3.14,18.93,18.93,0,0,1,5.57,3.29,12.67,12.67,0,0,1,3.18,5.51c1.17,3.86,1.08,6.62-.76,10.21-.8,1.56-.32,3.39-1.05,5s-3.78,3.37-2.95,4.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,117.29a3.1,3.1,0,0,1,2.77,3.14h0l-1.85,41.84c-.08,4.94-7.3,7.72-12.59,7.59h0c-5.34-.12-5.51-2.74-5.58-7.44-.11-7.86-.1-10.8-.1-10.76s-6.75-1.13-8.13-9.94c-.69-4.39-.45-11.57-.07-17.44.35-5.28,3.86-11.75,9.12-11.19Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.73,130.3a1.13,1.13,0,0,0,1.08,1.14,1.09,1.09,0,0,0,1.17-1,1.14,1.14,0,0,0-1.09-1.14A1.07,1.07,0,0,0,114.73,130.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,127.45c.14.15,1-.48,2.21-.48s2.11.62,2.24.47-.08-.33-.46-.61a3.1,3.1,0,0,0-1.8-.56,3,3,0,0,0-1.76.56C114.36,127.12,114.23,127.39,114.3,127.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.23,130.3a1.13,1.13,0,0,0,1.09,1.14,1.08,1.08,0,0,0,1.16-1,1.12,1.12,0,0,0-1.08-1.14A1.08,1.08,0,0,0,126.23,130.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.25,128.28c.14.14,1-.49,2.21-.48s2.11.61,2.24.47-.08-.34-.47-.62a3.11,3.11,0,0,0-1.79-.56,3,3,0,0,0-1.76.57C126.31,127.94,126.18,128.21,126.25,128.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.82,137.28a8.16,8.16,0,0,0-2-.36c-.31,0-.6-.1-.65-.31a1.54,1.54,0,0,1,.21-.92l.92-2.36a39.48,39.48,0,0,0,2.07-6.18,42,42,0,0,0-2.56,6c-.31.83-.61,1.62-.89,2.38a1.75,1.75,0,0,0-.16,1.21.77.77,0,0,0,.51.46,2.15,2.15,0,0,0,.53.07A7.91,7.91,0,0,0,121.82,137.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,151.66a22.35,22.35,0,0,0,11.8-3.12s-3,6.05-11.8,5.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.71,124.72c.12.33,1.34.17,2.76.35s2.58.57,2.77.27c.09-.14-.11-.45-.58-.77a4.64,4.64,0,0,0-2-.73,4.71,4.71,0,0,0-2.16.25C125.93,124.3,125.66,124.56,125.71,124.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.76,124.51c.21.27,1,0,2,0s1.86.19,2.06-.1c.09-.14-.05-.42-.42-.68a3,3,0,0,0-3.31.09C114.78,124.09,114.66,124.37,114.76,124.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,140.08a2,2,0,0,1,1.83-.76,1.86,1.86,0,0,1,1.29.7,1.18,1.18,0,0,1,.09,1.35,1.38,1.38,0,0,1-1.49.37,4.42,4.42,0,0,1-1.45-.87,1.3,1.3,0,0,1-.32-.34.4.4,0,0,1,0-.42",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.19,138.13c-.18,0-.19,1.22-1.24,2.09s-2.37.74-2.38.91.3.24.85.26a3.08,3.08,0,0,0,2-.69,2.72,2.72,0,0,0,1-1.75C125.41,138.43,125.28,138.13,125.19,138.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,116.42c.42,2.78,4.83,3.24,7.59,2.7a8.94,8.94,0,0,0,7.9,3.4,2.47,2.47,0,0,1,1.21,0,2.58,2.58,0,0,1,.9.9,7.86,7.86,0,0,0,4.79,3,7.09,7.09,0,0,0,5.36,5.81s.91-.45.59-4,.07-11,.07-11l-9.64-4.38-11.53-2.15S113.82,111.7,114.53,116.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.45,131.13a9.46,9.46,0,0,0-.6-2.47,6.28,6.28,0,0,0-5.12-3.75h-.16l0-.16a7.91,7.91,0,0,0-2.28-4,4.5,4.5,0,0,0-4.83-.81l-.26.13-.1-.29-.12-.32a6.89,6.89,0,0,0-5.67-4.39,7.43,7.43,0,0,0-1.7,0,3.8,3.8,0,0,1-1.74-.08,3.19,3.19,0,0,1-1.31-1,6,6,0,0,0-1-1,4.89,4.89,0,0,0-4-.77,8.09,8.09,0,0,0-1.44.58s.09-.11.31-.27a4.09,4.09,0,0,1,1.08-.5,5,5,0,0,1,4.25.66c.81.52,1.3,1.54,2.21,1.85s2.1-.18,3.36,0a7.35,7.35,0,0,1,6.11,4.7,2.79,2.79,0,0,1,.12.34l-.36-.15a5,5,0,0,1,5.38.9,8.12,8.12,0,0,1,2.38,4.31l-.19-.17a6.59,6.59,0,0,1,3.6,1.61,6.31,6.31,0,0,1,1.72,2.48,6.07,6.07,0,0,1,.4,1.89A2.09,2.09,0,0,1,146.45,131.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.23,121.82a1.9,1.9,0,0,1-.73.24,7.44,7.44,0,0,1-2.08.11,8.51,8.51,0,0,1-6-3.23l.32.08-.29.13a6.7,6.7,0,0,1-3.94.36,6.33,6.33,0,0,1-2.88-1.47,6,6,0,0,1-1.34-1.7,1.79,1.79,0,0,1-.27-.75,9.73,9.73,0,0,0,1.85,2.17A6.18,6.18,0,0,0,118.6,119a6.35,6.35,0,0,0,3.64-.37l.27-.12.19-.09.13.16a8.57,8.57,0,0,0,5.63,3.19A17.83,17.83,0,0,0,131.23,121.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,116.61c0,.15-1.29,0-2.79.39s-2.6,1-2.69.86a4.26,4.26,0,0,1,2.57-1.36A4.21,4.21,0,0,1,126.27,116.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.94,116.32c-.12.09-.57-.28-1.14-.69s-1.06-.72-1-.86.68,0,1.31.44S123.05,116.24,122.94,116.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.62,121.44c-.05.14-1.17-.22-2.57-.17s-2.5.45-2.56.31a4.71,4.71,0,0,1,5.13-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.06,126.16a6.67,6.67,0,0,1-3.57-.48,6.57,6.57,0,0,1-3.09-1.86c.09-.13,1.43.74,3.26,1.37S139.07,126,139.06,126.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.08,129.53a17.23,17.23,0,0,0-2.3-1.29,16.49,16.49,0,0,0-2.59-.45,3.16,3.16,0,0,1,2.77,0C144.48,128.29,145.2,129.47,145.08,129.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,116.88s-.14-.3-.45-.77a5.24,5.24,0,0,0-1.78-1.55,17.06,17.06,0,0,0-7.68-1.73,32.27,32.27,0,0,0-7.92,1c-2,.5-3.22.88-3.24.81a3.12,3.12,0,0,1,.82-.38c.54-.21,1.33-.49,2.32-.78a27.8,27.8,0,0,1,8-1.22,16,16,0,0,1,7.87,1.93,4.79,4.79,0,0,1,1.76,1.77A1.61,1.61,0,0,1,144.9,116.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.62,121.65a14.61,14.61,0,0,0-1.36-2.48,10.72,10.72,0,0,0-5.55-3.7,19.91,19.91,0,0,0-6.79-.52,24.82,24.82,0,0,1-2.87.2,11.88,11.88,0,0,1,2.83-.57,17.94,17.94,0,0,1,7,.39,10.39,10.39,0,0,1,5.7,4,7,7,0,0,1,.93,1.93A2,2,0,0,1,145.62,121.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,125.33a3.17,3.17,0,0,1-1.63-1.22,5.25,5.25,0,0,1,2.25-8.33,3.24,3.24,0,0,1,2-.24,14.74,14.74,0,0,0-1.88.58,5.1,5.1,0,0,0-2.1,7.77A14.55,14.55,0,0,0,112.63,125.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.57,139.16c0-.08.87-.5,2.18-1.38a6.28,6.28,0,0,0,1.88-1.92,3.48,3.48,0,0,0,.33-3.08,4.09,4.09,0,0,0-2.14-2.32,4.65,4.65,0,0,0-2.62-.32,9.44,9.44,0,0,0-2.38.86s.15-.21.52-.47a5.17,5.17,0,0,1,1.79-.75A4.94,4.94,0,0,1,151,130a4.49,4.49,0,0,1,2.43,2.58,3.93,3.93,0,0,1-.41,3.51,6.24,6.24,0,0,1-2.09,2,11.74,11.74,0,0,1-1.71.86A1.87,1.87,0,0,1,148.57,139.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,139.23a3,3,0,0,1,.36.78,20.81,20.81,0,0,1,.7,2.24,11.78,11.78,0,0,1,.36,3.48,7.46,7.46,0,0,1-1.42,4.08,5.38,5.38,0,0,1-3.77,2.1,3.84,3.84,0,0,1-3.25-1.32,3.48,3.48,0,0,1-.91-2.2,1.42,1.42,0,0,1,.16-.86s0,.32,0,.85a3.64,3.64,0,0,0,3.92,3.05,5,5,0,0,0,3.4-1.94,7.25,7.25,0,0,0,1.35-3.79,12.6,12.6,0,0,0-.24-3.37C149.29,140.42,148.89,139.26,149,139.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.58,168.32s-6.2,3.9-6.93,13.59-2.86,29.93-2.86,29.93l-23.65,5.78,2.63,14.19,39-10.88Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.19,164.78c-2.18-.93-15.75-3.41-15.75-3.41l-.67-7.26L121,155.73l-.65,7.84-13.74,4.75-.32,14.59,3.29,47.74,38.23,3.4a5.33,5.33,0,0,0,5.81-5.42l-.83-42.32S158.38,165.72,156.19,164.78Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.19,164.78s7.79,3,8.46,14.74c.43,7.74,3.15,20.95,5,29.07,1,4.56.75,9.68-1.77,13.62h0c-3.65,4.24-8.63,7.93-15.05,8.44H136.68l-7-11.13,18.57-5.42,4.41-26.78Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55,220.52a9.7,9.7,0,0,1-.24-1.28,16.29,16.29,0,0,0-1-3.39,9.24,9.24,0,0,0-3.17-4,6.85,6.85,0,0,0-2.77-1.15,9.46,9.46,0,0,0-3.25.16,103.1,103.1,0,0,0-11.31,3.1l-3.37,1.14a8,8,0,0,1-1.26.37,7,7,0,0,1,1.2-.53l3.33-1.28a83.45,83.45,0,0,1,11.32-3.24,9.82,9.82,0,0,1,3.41-.15,7.06,7.06,0,0,1,2.94,1.24,9.27,9.27,0,0,1,3.22,4.23,13.72,13.72,0,0,1,.86,3.48A5.88,5.88,0,0,1,159.55,220.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.07,187.36a3.4,3.4,0,0,1,.14.87c.06.56.11,1.37.17,2.38.09,2.12.21,4.84.35,7.84a59.57,59.57,0,0,0,.87,7.78c.38,2,.78,3.14.7,3.17a3.46,3.46,0,0,1-.35-.81c-.1-.26-.2-.59-.31-1s-.24-.82-.35-1.32a45.57,45.57,0,0,1-1-7.81c-.17-3.07-.19-5.85-.22-7.86,0-.93,0-1.72,0-2.38A3.63,3.63,0,0,1,149.07,187.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,224.64a6.18,6.18,0,0,1-.88.88,21,21,0,0,1-2.74,2,23.44,23.44,0,0,1-10.64,3.34,22.28,22.28,0,0,1-6.16-.46c-1.88-.4-3.46-1.07-4.83-1.39a21.84,21.84,0,0,0-3.33-.46,4.23,4.23,0,0,1-1.22-.25,11.22,11.22,0,0,1,1.24.07,19.1,19.1,0,0,1,3.38.33c1.42.29,3,.93,4.84,1.29a22.33,22.33,0,0,0,6.05.42,24.33,24.33,0,0,0,10.51-3.16A42.84,42.84,0,0,0,165.59,224.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84,177.45a4.05,4.05,0,0,1,.13,1.14,20.08,20.08,0,0,1-.17,3.11c-.17,1.3-.47,2.84-.85,4.52s-.79,3.54-1,5.5a17,17,0,0,0,.14,5.51,10.91,10.91,0,0,0,1.78,4.1,9.75,9.75,0,0,0,3.12,2.72.75.75,0,0,1-.29-.08,5.54,5.54,0,0,1-.78-.35,7.84,7.84,0,0,1-2.35-2.07,10.9,10.9,0,0,1-2-4.21,17,17,0,0,1-.19-5.68,53.42,53.42,0,0,1,1.08-5.54c.4-1.68.74-3.19,1-4.48C109.87,179.08,109.75,177.45,109.84,177.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,164c0,.08-.76.51-1.84,1.47A12.28,12.28,0,0,0,147.4,170a12.48,12.48,0,0,0-.87,5.48c.1,1.44.37,2.31.28,2.34a5.72,5.72,0,0,1-.64-2.3,11.28,11.28,0,0,1,4.23-10.32A5.69,5.69,0,0,1,152.47,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,164.19a13.71,13.71,0,0,1-.54-4.18,13.41,13.41,0,0,1,.25-4.2A23.6,23.6,0,0,1,123,160,22.28,22.28,0,0,1,123,164.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4,163.55a12.81,12.81,0,0,1-.84-4,12.91,12.91,0,0,1,0-4.13,22.3,22.3,0,0,1,.55,4.07A23.45,23.45,0,0,1,128.4,163.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21,163.14a14.5,14.5,0,0,1-.85-4.32,14.69,14.69,0,0,1,0-4.41,25.89,25.89,0,0,1,.54,4.35A26.73,26.73,0,0,1,134.21,163.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78,202.25s-.2.17-.62.35a8.06,8.06,0,0,1-1.84.55A10.14,10.14,0,0,1,126.49,198a8.17,8.17,0,0,1-.73-1.79,1.76,1.76,0,0,1-.12-.7c.09,0,.34.95,1.17,2.3a10.47,10.47,0,0,0,10.45,5C138.83,202.59,139.75,202.17,139.78,202.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,168.76l-.43-.17-1.21-.5a47.36,47.36,0,0,0-4.52-1.66,17.92,17.92,0,0,0-7-.79,26.89,26.89,0,0,0-8.28,2.62,73.57,73.57,0,0,1-8,3.5,16.3,16.3,0,0,1-7.08.87,10.74,10.74,0,0,1-4.55-1.56,7.1,7.1,0,0,1-1.37-1.12s.13.09.36.29a7.28,7.28,0,0,0,1.06.76,10.78,10.78,0,0,0,4.52,1.48,16.34,16.34,0,0,0,7-.9,74,74,0,0,0,8-3.51,26.5,26.5,0,0,1,8.35-2.62,17.71,17.71,0,0,1,7.09.84,41.06,41.06,0,0,1,4.51,1.73l1.2.54C147.13,168.68,147.27,168.76,147.27,168.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.18,174l-.17.09-.49.22a17,17,0,0,1-1.85.68,22.83,22.83,0,0,1-6.41,1.07,23.34,23.34,0,0,1-6.45-.77,16.44,16.44,0,0,1-1.88-.6l-.5-.2a.48.48,0,0,1-.17-.08.58.58,0,0,1,.18,0l.51.16c.44.15,1.09.34,1.89.54a25.26,25.26,0,0,0,6.42.7,24.5,24.5,0,0,0,6.37-1c.8-.23,1.43-.45,1.86-.62L164,174C164.11,174,164.17,174,164.18,174Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,187.93a3.44,3.44,0,0,1-.68-.07,17.42,17.42,0,0,0-1.86-.14,18,18,0,0,0-11.48,3.75,15.5,15.5,0,0,0-1.41,1.21,3.07,3.07,0,0,1-.52.46s.16-.19.46-.51a14.7,14.7,0,0,1,1.38-1.28,17.55,17.55,0,0,1,5.44-2.95,17.36,17.36,0,0,1,6.13-.83,12.72,12.72,0,0,1,1.87.21A4,4,0,0,1,165.18,187.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.73,212.58a4.28,4.28,0,0,0-.08-.8,3.38,3.38,0,0,0-1.23-1.77,5.27,5.27,0,0,0-3-1c-1.23-.06-2.6.09-4,0a27.4,27.4,0,0,1-7.27-1.16,22,22,0,0,1-2.1-.74l-.56-.24a1.07,1.07,0,0,1-.19-.09l.2.05.57.21c.5.17,1.22.42,2.12.67a29.45,29.45,0,0,0,7.23,1.09c1.43,0,2.8-.1,4,0a5.28,5.28,0,0,1,3.13,1.05,3.39,3.39,0,0,1,1.22,1.86A1.93,1.93,0,0,1,169.73,212.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.7,230.14s.06-.3.16-.83a15.59,15.59,0,0,0,.28-2.3,16.4,16.4,0,0,0-1.31-7.43,16.57,16.57,0,0,0-4.56-6,17.73,17.73,0,0,0-1.88-1.35,6.52,6.52,0,0,1-.72-.45,12.74,12.74,0,0,1,2.69,1.69A15.76,15.76,0,0,1,153.29,227,12.13,12.13,0,0,1,152.7,230.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.76,188.86s-.22-.55-.81-1.42a8.91,8.91,0,0,0-3.36-2.81,13.53,13.53,0,0,0-6.37-1.31,27.05,27.05,0,0,0-7.84,1.78c-2.7,1-5.25,2-7.68,2.59a19.74,19.74,0,0,1-6.58.59,11.41,11.41,0,0,1-4.28-1.24,8,8,0,0,1-1-.65l-.33-.25s.47.35,1.4.83a11.71,11.71,0,0,0,4.25,1.16,19.84,19.84,0,0,0,6.53-.63c2.4-.6,4.94-1.64,7.65-2.6a26.93,26.93,0,0,1,7.9-1.77,13.49,13.49,0,0,1,6.44,1.37,8.81,8.81,0,0,1,3.37,2.9,6.67,6.67,0,0,1,.58,1.07C147.71,188.72,147.76,188.86,147.76,188.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19,203.61s-.29.26-.71.46-.77.34-.8.29.29-.26.71-.47S112.17,203.55,112.19,203.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.28,203.7a10.56,10.56,0,0,1-3.06.56,33.11,33.11,0,0,1-7.49-.72,25.19,25.19,0,0,0-7.45-.42,11.36,11.36,0,0,0-2.21.5c-.51.17-.78.28-.79.27a9.07,9.07,0,0,1,3-.92,24,24,0,0,1,7.5.37,37.43,37.43,0,0,0,7.45.78,14,14,0,0,0,2.25-.26A6.79,6.79,0,0,1,135.28,203.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.66,202.8s-.65-.3-1.74-.67a15.18,15.18,0,0,0-4.42-.77,14.61,14.61,0,0,0-4.44.61c-1.1.33-1.75.64-1.77.61a1.92,1.92,0,0,1,.45-.24,8.62,8.62,0,0,1,1.28-.51,13.47,13.47,0,0,1,4.49-.68A13.93,13.93,0,0,1,148,202a11.15,11.15,0,0,1,1.26.56A2.1,2.1,0,0,1,149.66,202.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13,215.53a.6.6,0,0,1-.18.11l-.52.26a20.73,20.73,0,0,1-2,.82,25.1,25.1,0,0,1-14,.85,19.14,19.14,0,0,1-2.07-.58l-.55-.19-.19-.08s.07,0,.2,0l.57.16c.48.14,1.19.32,2.07.51a26.66,26.66,0,0,0,13.91-.85c.85-.29,1.53-.55,2-.76l.53-.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,183.86s-.52-.26-1.4-.56a9.49,9.49,0,0,0-7,.42c-.84.4-1.3.76-1.33.73a2.22,2.22,0,0,1,.32-.27,6.63,6.63,0,0,1,.94-.59,8.91,8.91,0,0,1,7.17-.43,6.5,6.5,0,0,1,1,.48A2.29,2.29,0,0,1,109.61,183.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.15,196.75a6.7,6.7,0,0,0,2.8,8.36,9.5,9.5,0,0,0,10.07-.36c.54-.4,1-1.11.58-1.58s-1-.29-1.55-.21a11.83,11.83,0,0,1-7.09-1.23,10.09,10.09,0,0,1-4.75-5"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "103.41 225.88 126.18 225.47 113.49 231.53 103.41 225.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.18,193.08,65,231.63a3.14,3.14,0,0,0,3.1,2.44l45.55-.52,12.5-6.15-.2-1.75-10.85,4.88-6.8-40.13a3.11,3.11,0,0,0-3-2.91l-46.84,2.59A2.46,2.46,0,0,0,56.18,193.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6,225.92c1.44,2,2.67.35,4.33-.28a10.22,10.22,0,0,0,2.26-1.19l-.38,5.9-3.52,2.5s0,1.59,2.31,1.75a7.93,7.93,0,0,0,3.27-.24l.12.78a1.85,1.85,0,0,0,1.78,1.56,2.35,2.35,0,0,0,1.09-.18,5,5,0,0,0,4.62,0,4.1,4.1,0,0,0,2.12-3.73l3.61-7.22,1-.3a5.6,5.6,0,0,0-.91-6.71,6.11,6.11,0,0,0-6.28-1.37l-4.78,1.58a4.89,4.89,0,0,0-3.39.9c-.79.58-3.89,2.76-3.89,2.76Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4,229.12c.07,0,.14.38.22,1a7.16,7.16,0,0,1,0,2.46,2.61,2.61,0,0,1-.65,1.27,2.24,2.24,0,0,1-1,.61c-.67.17-1.06-.11-1-.15s.4.07.93-.15a2.28,2.28,0,0,0,1.31-1.68,11.08,11.08,0,0,0,.13-2.35C126.31,229.51,126.34,229.13,126.4,229.12Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19,224.45a9.57,9.57,0,0,1,0,3,10.15,10.15,0,0,1-.41,2.94,9.55,9.55,0,0,1,0-3A10,10,0,0,1,122.19,224.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39,230.53a2.62,2.62,0,0,1,.23,1.15,4.93,4.93,0,0,1-.52,2.82,4.38,4.38,0,0,1-2.23,1.8,2.3,2.3,0,0,1-1.15.25c0-.07.4-.22,1-.54a4.81,4.81,0,0,0,2-1.74,5.51,5.51,0,0,0,.58-2.58A3.86,3.86,0,0,1,130.39,230.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.88,228a14.58,14.58,0,0,1,1.11-2.15,6.73,6.73,0,0,0,.7-2.46,6.11,6.11,0,0,0-2.33-5.49,6.91,6.91,0,0,0-2.27-1.14,18.79,18.79,0,0,0-2.37-.38,1.77,1.77,0,0,1,.65-.1,6.75,6.75,0,0,1,1.8.17,6.93,6.93,0,0,1,2.44,1.12,6.24,6.24,0,0,1,2,2.6,6.33,6.33,0,0,1,.45,3.27,6.6,6.6,0,0,1-.83,2.55,13.11,13.11,0,0,1-1,1.5A2.34,2.34,0,0,1,136.88,228Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,210.61a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,85.68,210.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,126.5c-1.19,2.06-.52,4.68.46,6.85s2.25,4.34,2.2,6.71c-.07,4-3.82,7.3-3.55,11.28a6,6,0,0,0,4.2,5.18c-1.81-1.37-1.82-4.15-1-6.25s4.63-7.58,5.26-9.76c2.11-7.32,1.44-8.23-1-11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.64,132.19a2.34,2.34,0,0,1-1.38,0,5.73,5.73,0,0,1-4.44-4.59c-.15-.86,0-1.39,0-1.38a8.6,8.6,0,0,1,.33,1.3,6.28,6.28,0,0,0,4.19,4.32A8.89,8.89,0,0,1,143.64,132.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31,154.11s-.1-.05-.25-.19a3.35,3.35,0,0,1-.59-.68,5,5,0,0,1-.83-3.19,4.8,4.8,0,0,1,.7-2.21,9.83,9.83,0,0,1,1.77-2,7.68,7.68,0,0,0,1.73-2.14,6.47,6.47,0,0,0,.69-2.84,6.08,6.08,0,0,0-.65-2.84,17,17,0,0,0-1.53-2.35,16.6,16.6,0,0,1-2.47-4.2,9.16,9.16,0,0,1-.62-3.24,3,3,0,0,1,.16-1.19,10.75,10.75,0,0,0,.81,4.29,17,17,0,0,0,2.5,4.05,16,16,0,0,1,1.6,2.41,6.53,6.53,0,0,1,.72,3.08,6.73,6.73,0,0,1-.76,3.06,8,8,0,0,1-1.85,2.26,9.79,9.79,0,0,0-1.73,1.83,4.46,4.46,0,0,0-.7,2,5.07,5.07,0,0,0,.63,3C139,153.78,139.35,154.07,139.31,154.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.53,132s.22.14.52.49a6.23,6.23,0,0,1,1,1.69,9.17,9.17,0,0,1-.09,6.35,15.78,15.78,0,0,1-3.52,5.32,9.52,9.52,0,0,1-2,1.74,21.8,21.8,0,0,1,1.7-2,17.65,17.65,0,0,0,3.3-5.25,9.45,9.45,0,0,0,.23-6A14.49,14.49,0,0,0,144.53,132Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.63,233.55a.81.81,0,0,1-.06-.24l-.12-.7c-.1-.66-.24-1.56-.41-2.7-.37-2.39-.88-5.78-1.51-9.94s-1.44-9.19-2.42-14.71c-.5-2.76-1-5.66-1.67-8.64-.31-1.49-.67-3-1-4.53a4.85,4.85,0,0,0-1-2,3.07,3.07,0,0,0-2-.92,13.3,13.3,0,0,0-2.36,0l-2.38.15-4.65.31-8.79.56-14.89.93-10,.57-2.73.13-.71,0h-.24s.08,0,.24-.05l.7-.07,2.73-.23,10-.74,14.88-1,8.79-.59,4.65-.31,2.38-.16a13.45,13.45,0,0,1,2.46,0,3.64,3.64,0,0,1,2.29,1.09,5.28,5.28,0,0,1,1.09,2.23c.39,1.54.74,3,1,4.55.63,3,1.15,5.9,1.64,8.66,1,5.54,1.71,10.54,2.31,14.74s1,7.61,1.35,10c.13,1.15.24,2.05.31,2.72,0,.28,0,.52.07.71A1.08,1.08,0,0,1,113.63,233.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.25,177.21s0-.16.08-.45.15-.74.27-1.3c.26-1.16.63-2.83,1.1-5,1-4.35,2.4-10.6,4.15-18.33,3.56-15.49,8.47-36.89,13.91-60.59L419,90.5l.25,1.07c.09.42.2.88.3,1.34l13.86,61.56c1.74,7.86,3.16,14.23,4.14,18.66.48,2.19.85,3.9,1.1,5.08.12.57.21,1,.28,1.33a3.92,3.92,0,0,1,.07.45s-.05-.15-.12-.44-.19-.75-.32-1.32c-.28-1.17-.68-2.88-1.2-5.06l-4.3-18.63c-3.58-15.76-8.53-37.5-14-61.52-.1-.46-.21-.92-.3-1.34h.49c-5.5,23.68-10.46,45.06-14.06,60.55-1.81,7.71-3.28,14-4.3,18.29-.51,2.14-.91,3.81-1.19,5-.14.54-.25,1-.32,1.28S399.25,177.21,399.25,177.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,195.2V180h40.58V195.2a17.71,17.71,0,0,1-17.71,17.71H417A17.71,17.71,0,0,1,399.24,195.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,180a5.32,5.32,0,0,1,.46.64l1.24,1.88c1.08,1.69,2.6,4.07,4.47,7L420,212.61l.11.17h-.43l14.16-23.25c1.81-2.92,3.28-5.31,4.33-7l1.2-1.89a3.86,3.86,0,0,1,.45-.64,4.91,4.91,0,0,1-.36.69l-1.12,1.95c-1,1.71-2.45,4.12-4.2,7.09l-14,23.32-.21.35-.22-.35-.1-.16c-5.64-9-10.74-17.23-14.47-23.2l-4.34-7.06-1.16-1.94A3.58,3.58,0,0,1,399.24,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.56,91.43A4.43,4.43,0,1,1,419.13,87,4.43,4.43,0,0,1,423.56,91.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.13,16c.14,0,.25,17.07.25,38.12s-.11,38.13-.25,38.13-.25-17.07-.25-38.13S419,16,419.13,16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.43,214.56a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,421.43,214.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.69,215.27l.3-.15a4.21,4.21,0,0,0-1.91,3.14,11.17,11.17,0,0,0,.32,3.77c.09.4.29.89.7.87s.53-.46.6-.82a8.22,8.22,0,0,0,.05-2.27,4,4,0,0,0,.88,2.68c.12.15.29.3.47.25s.25-.24.3-.42a8.5,8.5,0,0,0,.28-1.95,3,3,0,0,0,.61,1.59,1.05,1.05,0,0,0,1.51.1A1.46,1.46,0,0,0,423,221a13.09,13.09,0,0,0-2.65-6.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.79,180s-18.23-21-16.2-21.77,18.23,10.88,18.23,10.88S389.89,138,392.68,135.68s17.47,27.6,17.47,27.6-2.28-43.55,0-44.06,10.63,43.55,10.63,43.55,12.41-40.26,16-40.26-3.8,38.74-3.8,38.74,14.68-24.81,17-21.52-10.38,30.13-10.38,30.13,18.49-15.44,19.25-13.42-20,23.55-20,23.55Z",
    style: {
      fill: "#5DAC32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.25,148.34c.13-.06,3.36,6.88,7.22,15.48s6.89,15.64,6.77,15.69S409.88,172.64,406,164,399.12,148.4,399.25,148.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,152.21c.14,0,.67,6.1,1.2,13.65s.84,13.67.7,13.68-.68-6.1-1.2-13.65S413.84,152.22,414,152.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.29,132.71a1.85,1.85,0,0,1-.1.49c-.11.37-.24.83-.4,1.39-.39,1.27-.9,3-1.53,5.07-1.29,4.28-3,10.22-4.77,16.81s-3.22,12.6-4.24,16.95c-.49,2.13-.9,3.87-1.2,5.16-.14.56-.25,1-.35,1.4a1.56,1.56,0,0,1-.15.48,1.72,1.72,0,0,1,.05-.5c.07-.38.15-.85.26-1.42.22-1.23.58-3,1.05-5.2.93-4.37,2.33-10.4,4.09-17s3.55-12.52,4.92-16.78c.69-2.14,1.26-3.85,1.68-5l.49-1.36A2.35,2.35,0,0,1,434.29,132.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.08,155.16c.11.08-3.45,5.38-7.95,11.85s-8.25,11.64-8.36,11.56,3.45-5.38,8-11.85S443,155.08,443.08,155.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,179.55a7.15,7.15,0,0,1-1.6-1.14,46.32,46.32,0,0,1-3.47-3.21,41.68,41.68,0,0,1-3.11-3.55,6.73,6.73,0,0,1-1.1-1.62c.11-.09,2,2.21,4.57,4.82S408,179.43,408,179.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,171.2a18.88,18.88,0,0,1,.65,4.33,19.52,19.52,0,0,1,.14,4.38,20.23,20.23,0,0,1-.64-4.33A19.21,19.21,0,0,1,419,171.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.82,189.47a9.91,9.91,0,0,1-1.57.32c-1,.18-2.49.41-4.31.67a141.52,141.52,0,0,1-14.34,1.27,91.21,91.21,0,0,1-14.39-.6c-1.83-.24-3.3-.48-4.31-.69a10.91,10.91,0,0,1-1.56-.37,9.18,9.18,0,0,1,1.59.17c1,.16,2.49.35,4.32.54a105.94,105.94,0,0,0,14.33.45c5.61-.19,10.66-.71,14.32-1.13l4.32-.5A8.61,8.61,0,0,1,439.82,189.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.82,194a11.6,11.6,0,0,1-1.57.32c-1,.18-2.49.41-4.31.66a141.14,141.14,0,0,1-14.34,1.28,91.21,91.21,0,0,1-14.39-.6c-1.83-.24-3.3-.48-4.31-.7a8.28,8.28,0,0,1-1.56-.37,11.9,11.9,0,0,1,1.59.18c1,.16,2.49.35,4.32.54a107.61,107.61,0,0,0,14.33.45c5.61-.2,10.66-.71,14.32-1.13l4.32-.5A8.61,8.61,0,0,1,439.82,194Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintingInvoice);
export default __webpack_public_path__ + "static/media/printing_invoice.433bb38ba47a8d37a22cfb2738af98a4.svg";
export { ForwardRef as ReactComponent };